import { render, staticRenderFns } from "./personCenterLayout.vue?vue&type=template&id=646c89da&scoped=true"
import script from "./personCenterLayout.vue?vue&type=script&lang=js"
export * from "./personCenterLayout.vue?vue&type=script&lang=js"
import style0 from "./personCenterLayout.vue?vue&type=style&index=0&id=646c89da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c89da",
  null
  
)

export default component.exports